// src/containers/AdminOffice/pages/Orders.jsx
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAboutUs, updateOrder } from "../../actions";
import { RenderOrders } from "./RenderOrders";
import { MainContainer } from "./../MainContainer";
import {
  getCustomerOrders,
  deleteOrderById,
  updateOrderTotalAmount,
  updateOrderVisibleByIdAdmin
} from "./../../actions/order.action";
import OrderModalCenter from "./OrderModalCenter";
import RenderSettingOrderProductModal from "./RenderSettingOrderProductModal";
import RenderAddAdditionalFieldModal from "./RenderAddAdditionalFieldModal";
import AlertComponent from "./../../components/Alert/Alert";
import { setCloseAlertAdditionalField } from "./../../reducers/order.reducer";
import AddPaymentAccountModal from "./PaymentAccount/AddPaymentAccountModal";
import RenderSettingOrderNumberModal from "./RenderSettingOrderNumberModal";

const Orders = () => {
  const order = useSelector((state) => state.order);
  const aboutUs = useSelector((state) => state.aboutUs);
  const { orders, showAlert, variantAlert, message, loading, orderDetails } = order;

  const dispatch = useDispatch();

  const [type, setType] = useState("");
  const [show, setShow] = useState(false);
  const [clicked, setClicked] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [showSettingModal, setShowSettingModal] = useState(false);
  const [productOrderDetails, setProductOrderDetails] = useState(null);
  const [showAddAdditionalField, setShowAddAdditionalField] = useState(false);
  const [showPaymentAccountModal, setShowPaymentAccountModal] = useState(false);
  const [showOrderSettingModal, setShowOrderSettingModal] = useState(false);
  const [showDeletingConfirmation, setShowDeletingConfirmation] = useState(false);
  const [showOrderNumberAdditionalModal, setShowOrderNumberAdditionalModal] = useState(false);
  const [typeOrderModalCenter, setTypeOrderModalCenter] = useState("");
  const [_orderId, setOrderId] = useState("");
  const [dataAdditional, setDataAdditional] = useState(false);
  const [showSettingEditModal, setShowSettingEditModal] = useState(false);
  const [typeEditOrderModal, setTypeEditOrderModal] = useState("");

  // фильтры и поиск
  const [valueTabsSort, setValueTabsSort] = useState("");
  const [valueSort, setValueSort] = useState("createdAtMinus");
  const [searchMainName, setSearchMainName] = useState("");

  // фикс: запрет скролла во время модалок
  useEffect(() => {
    if (showSettingModal || showAddAdditionalField) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showSettingModal, showAddAdditionalField]);

  // 🔒 стабильный объект, который уходит глубже в дерево
  const orderData = useMemo(
    () => ({ valueTabsSort, searchMainName }),
    [valueTabsSort, searchMainName]
  );

  // ✅ единый эффект загрузки/перезагрузки списка
  useEffect(() => {
    dispatch(getCustomerOrders(searchMainName || "", valueTabsSort, valueSort));
  }, [dispatch, searchMainName, valueTabsSort, valueSort]);

  // ===== handlers (мемоизированы) =====
  const onOrderUpdate = useCallback(
    (orderId) => {
      const payload = { orderId, type };
      dispatch(updateOrder(payload));
      setModalShow(false);
    },
    [dispatch, type]
  );

  const handleShow = useCallback(() => setShow(true), []);

  const handleShowSettingModal = useCallback((item) => {
    setShowSettingModal(true);
    setProductOrderDetails(item);
  }, []);

  const handleShowEditOrderModal = useCallback((t) => {
    switch (t) {
      case "deliveryId":
      case "address":
      case "pickupPointsId":
      case "paymentId":
        setTypeEditOrderModal(t);
        break;
      default:
        setTypeEditOrderModal("");
        break;
    }
  }, []);

  const showOrderModal = useCallback((t) => {
    switch (t) {
      case "deliveryId":
      case "address":
      case "pickupPointsId":
      case "paymentId":
        setTypeOrderModalCenter(t);
        break;
      default:
        setTypeOrderModalCenter("");
        break;
    }
    setModalShow((s) => !s);
  }, []);

  const confirmDelete = useCallback(
    (deleteId) => {
      dispatch(deleteOrderById(deleteId));
      setShowDeletingConfirmation(false);
      setClicked(null);
    },
    [dispatch]
  );

  const confirmVisibleOrderById = useCallback(() => {
    if (!_orderId) return;
    dispatch(updateOrderVisibleByIdAdmin({ orderId: _orderId }));
  }, [dispatch, _orderId]);

  const handleTotalAmount = useCallback(
    (totalAmount, orderId) => {
      if (!orderId || typeof orderId !== "string" || orderId.length !== 24) {
        console.warn("❌ orderId некорректный:", orderId);
        return;
      }
      dispatch(
        updateOrderTotalAmount({
          typeSetMain: "totalAmount",
          totalAmount,
          orderId
        })
      );
    },
    [dispatch]
  );

  const formatDate = useCallback((date) => {
    if (date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
    }
    return "";
  }, []);

  return (
    <MainContainer
      noneSelectUpdatedPictures
      additionalData={orderData}                // 🔒 стабильный объект
      setValueTabsSort={setValueTabsSort}
      buttonText="Оформить заказ вручную"
      handleShow={handleShow}
      get={getCustomerOrders}
      sortItems={valueSort}
      typeSort="orderSort"
      setSearchMainName={setSearchMainName}
      search={getCustomerOrders}
      title="Все заказы"
      noneHrefButton
      propsType
      fluid
      type="fullFunctional"
      tabs
    >
      <OrderModalCenter
        typeOrderModalCenter={typeOrderModalCenter}
        onHide={() => setModalShow(false)}
        onOrderUpdate={onOrderUpdate}
        formatDate={formatDate}
        orderDetails={orderDetails}
        setType={setType}
        loading={loading}
        show={modalShow}
      />

      {searchMainName !== "" && (
        <div style={{ margin: "20px auto", textAlign: "center" }}>
          <h2>Результаты поиска "{searchMainName}"</h2>
          <h4>Найдено "{orders.length}" заказов</h4>
        </div>
      )}

      <RenderOrders
        orderDetails={orderDetails}
        searchMainName={searchMainName}
        typeEditOrderModal={typeEditOrderModal}
        handleShowEditOrderModal={handleShowEditOrderModal}
        showSettingEditModal={showSettingEditModal}
        setShowSettingEditModal={setShowSettingEditModal}
        setShowOrderNumberAdditionalModal={setShowOrderNumberAdditionalModal}
        setShowDeletingConfirmation={setShowDeletingConfirmation}
        setShowPaymentAccountModal={setShowPaymentAccountModal}
        showDeletingConfirmation={showDeletingConfirmation}
        setShowOrderSettingModal={setShowOrderSettingModal}
        confirmVisibleOrderById={confirmVisibleOrderById}
        handleShowSettingModal={handleShowSettingModal}
        handleTotalAmount={handleTotalAmount}
        showOrderModal={showOrderModal}
        confirmDelete={confirmDelete}
        setOrderId={setOrderId}
        setClicked={setClicked}
        orderId={_orderId}
        loading={loading}
        clicked={clicked}
        orders={orders}
      />

      <RenderSettingOrderProductModal
        setShowAddAdditionalField={setShowAddAdditionalField}
        onHide={() => setShowSettingModal(false)}
        productOrderDetails={productOrderDetails}
        dataAdditional={dataAdditional}
        show={showSettingModal}
        orderDetails={orderDetails}
        loading={loading}
      />

      <RenderAddAdditionalFieldModal
        setShowAddAdditionalField={setShowAddAdditionalField}
        showAddAdditionalField={showAddAdditionalField}
        onHide={() => setShowAddAdditionalField(false)}
        productOrderDetails={productOrderDetails}
        setDataAdditional={setDataAdditional}
        orderDetails={orderDetails}
      />

      <AddPaymentAccountModal
        orderDetails={orderDetails}
        show={showPaymentAccountModal}
        onHide={() => setShowPaymentAccountModal(false)}
      />

      <RenderSettingOrderNumberModal
        orderDetails={orderDetails}
        show={showOrderNumberAdditionalModal}
        onHide={() => setShowOrderNumberAdditionalModal(false)}
      />

      <AlertComponent
        dispatchCloseAlert={setCloseAlertAdditionalField}
        color={variantAlert}
        showObj={showAlert}
        text={message}
      />
    </MainContainer>
  );
};

export default Orders;
